// extracted by mini-css-extract-plugin
module.exports = {"duckCanvas":"CasesDucks_duckCanvas__S70OL"};